<template>
  <div class="order text-neutral-500">
    <div class="bg-white">
      <div class="flex justify-between items-center gap-3 p-6 shadow-border-b mdmax:flex-col mdmax:items-start">
        <div class="flex gap-3 mdmax:items-start mdmax:gap-1 mdmax:flex-col justify-between items-center">
          <span>
            <span class="inline-flex px-2 py-1 text-sm rounded-md mdmax:flex-shrink-0 capitalize" :class="statusClass || 'text-neutral-500 bg-neutral-300'">{{
              pickupAssignmentDetail.courier_type
            }}</span>
          </span>
          <div>
            <span class="text-neutral-500 mdmax:text-sm block text-xs mb-1">{{ pickupAssignmentDetail.order_delivery_schedule | formatDate }} / {{ pickupAssignmentDetail.id }}</span>
            <span class="text-neutral-500 mdmax:text-sm block text-xs">Kode Booking: {{ pickupAssignmentDetail.order_booking_code }}</span>
          </div>
        </div>
        <div class="courier flex items-center gap-6" v-if="pickupAssignmentDetail?.courier_assigned?.id">
          <div class="partner w-10 h-10 rounded-full flex justify-center items-center" v-if="pickupAssignmentDetail?.courier_assigned.partner_icon">
            <img :src="pickupAssignmentDetail?.courier_assigned.partner_icon" class="rounded-full" />
          </div>
          <div class="flex gap-3 items-center">
            <div class="w-7 h-7 rounded-full flex justify-center items-center">
              <img :src="pickupAssignmentDetail?.courier_assigned?.photo" class="rounded-full" />
            </div>
            <div class="">
              <p class="text-sm">{{ pickupAssignmentDetail?.courier_assigned?.name }}</p>
              <p class="text-neutral-500 text-xs">{{ pickupAssignmentDetail?.courier_assigned?.phone_number }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="flex mdmax:flex-col">
        <div class="flex-1">
          <div class="p-6 shadow-border-b">
            <p class="text-xl font-bold mb-6 text-neutral-700">Berat dan Jenis Paket</p>
            <div class="flex justify-start gap-6 mb-4 last:mb-0">
              <div class="w-2/5">
                <p class="text-sm font-medium mb-1 text-neutral-700">Berat Barang</p>
                <p>{{ pickupAssignmentDetail.package_weight_kilos }}kg</p>
              </div>
              <div class="w-3/5">
                <p class="text-sm font-medium mb-1 text-neutral-700">Jenis Paket</p>
                <p>{{ pickupAssignmentDetail.package_goods_category_display }}</p>
              </div>
            </div>
          </div>
          <div class="p-6">
            <p class="text-xl font-bold mb-6 text-neutral-700">Info Pengiriman</p>
            <div class="flex justify-start gap-6 mb-6">
              <div class="w-2/5">
                <p class="text-sm font-medium mb-1 text-neutral-700">Nama Pengirim</p>
                <p>{{ pickupAssignmentDetail?.sender?.name || '-' }}</p>
              </div>
              <div class="w-3/5">
                <p class="text-sm font-medium mb-1 text-neutral-700">No. HP Pengirim</p>
                <p>{{ pickupAssignmentDetail?.sender?.phone_number || '-' }}</p>
              </div>
            </div>
            <p class="text-sm font-medium mb-1 text-neutral-700">Alamat Pengirim</p>
            <p>{{ pickupAssignmentDetail?.sender?.address || '-' }}</p>
            <div class="mt-6 p-2 bg-neutral-200 rounded-md">
              <p class="text-sm font-medium mb-1 text-neutral-700">Detail Pickup</p>
              <p>{{ pickupAssignmentDetail?.sender?.address_detail_instruction || '-' }}</p>
            </div>
          </div>
          <div class="p-6 mdmax:shadow-border-b">
            <p class="text-xl font-bold mb-6 text-neutral-700">Info Penerima</p>
            <div class="flex justify-start gap-6 mb-6">
              <div class="w-2/5">
                <p class="text-sm font-medium mb-1 text-neutral-700">Nama Penerima</p>
                <p>{{ pickupAssignmentDetail?.receiver?.name || '-' }}</p>
              </div>
              <div class="w-3/5">
                <p class="text-sm font-medium mb-1 text-neutral-700">No. HP Penerima</p>
                <p>{{ pickupAssignmentDetail?.receiver?.phone_number || '-' }}</p>
              </div>
            </div>
            <p class="text-sm font-medium mb-1 text-neutral-700">Alamat Penerima</p>
            <p>{{ pickupAssignmentDetail?.receiver?.address || '-' }}</p>
            <div class="mt-6 p-2 bg-neutral-200 rounded-md">
              <p class="text-sm font-medium mb-1 text-neutral-700">Detail Pickup</p>
              <p>{{ pickupAssignmentDetail?.receiver?.address_detail_instruction || '-' }}</p>
            </div>
          </div>
        </div>
        <div class="flex-1 shadow-border-l mdmax:shadow-none">
          <div class="p-6">
            <p class="text-xl font-bold mb-6 text-neutral-700">Status Pengiriman</p>
            <div class="flex gap-5" v-for="(tracking, index) in pickupAssignmentDetail?.delivery_statuses" :key="'tracking' + index">
              <div class="line relative">
                <span class="inline-block w-5 h-5 rounded-full border-4 relative z-1" :class="index === 0 ? 'bg-primary-500 border-primary-100' : 'bg-neutral-500 border-neutral-300'"></span>
                <span class="absolute border-dashed border-neutral-300 h-full w-px border left-1/2 transform -translate-x-1/2 top-0 z-0"></span>
              </div>
              <div class="status mb-6">
                <p class="text-sm mb-1">{{ tracking.created_time | formatDateTime }}</p>
                <p class="text-neutral-700 mb-1">{{ tracking.title }}</p>
                <p class="text-sm">{{ tracking.subtitle }}</p>
              </div>
            </div>
          </div>
          <div class="p-6" v-if="!pickupAssignmentDetail?.courier_assigned?.id && pickupAssignmentDetail.courier_type === 'internal'">
            <div class="flex justify-between items-center mb-6">
              <p class="text-xl font-bold text-neutral-700">Kurir Terdekat</p>
              <div class="relative">
                <TextField type="text" :withIcon="true" placeholder="Cari kurir" v-model="courierSearchTerm" @enter="searchCourier()" />
                <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
                  <Search />
                </div>
              </div>
            </div>
            <TableComponent :columns="columns" :list="filteredData" emptyMessage="Tidak tersedia kurir dekat dari lokasi. Silakan gunakan pencarian kurir di atas.">
              <template slot="table-row" slot-scope="{ entry, column, index }">
                <span v-if="column.field === 'no'">{{ index + 1 }}</span>
                <Button
                  v-else-if="column.field === 'action'"
                  :buttonText="selectedCourier === entry.courier_id ? 'Ditugaskan' : 'Tugaskan'"
                  @action="selectCourier(entry.courier_id)"
                  :type="selectedCourier === entry.courier_id ? 'primary' : 'secondary'"
                  size="small"
                />
                <span v-else-if="column.field === 'courier'">
                  <div class="flex items-center gap-3">
                    <div class="w-7 h-7 rounded-full flex justify-center items-center" v-if="entry.courier_photo">
                      <img :src="entry.courier_photo" class="rounded-full" />
                    </div>
                    <div class="">
                      <p class="text-sm font-bold">{{ entry.courier_name }}</p>
                      <p class="text-neutral-500 text-xs">{{ entry.courier_phone_number }}</p>
                    </div>
                  </div>
                </span>
                <span v-else-if="column.field === 'distance_in_meter'" class="block">
                  {{ convertDistance(entry[column.field]) }}
                </span>
                <span v-else>{{ entry[column.field] || '-' }}</span>
              </template>
            </TableComponent>
            <div class="mt-8 flex justify-end items-center mb-6" v-if="filteredData && filteredData.length > 0">
              <pagination :currentPage="currentPage" :totalCount="totalRecords" :pageSize="pageSize" @onPageChange="onPageChange" />
            </div>
          </div>
          <div class="p-6" v-else>
            <p class="text-xl font-bold text-neutral-700 mb-6">Info Kurir</p>
            <div class="flex flex-col justify-center items-center">
              <div class="w-24 h-24 rounded-full flex justify-center items-center mb-3">
                <img :src="pickupAssignmentDetail?.courier_assigned?.photo" class="rounded-full" />
              </div>
              <div class="mb-8 text-neutral-700" v-if="pickupAssignmentDetail?.courier_assigned?.partner_name">{{ pickupAssignmentDetail?.courier_assigned?.partner_name }} Driver</div>
              <p class="font-bold text-lg text-neutral-700 mb-2">{{ pickupAssignmentDetail?.courier_assigned?.name }}</p>
              <p class="text-lg">{{ pickupAssignmentDetail?.courier_assigned?.phone_number }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="text-xs p-4 flex items-center gap-2 bg-secondary-100 text-neutral-700">
        <Info width="24" height="24" color="neutral-700" />Pastikan kurir yang di tugaskan tidak terlalu jauh dari jarak pengambilan.
      </div>
      <div class="flex justify-end py-2 px-6" v-if="error">
        <p class="text-system-error">{{ error }}</p>
      </div>
      <div class="p-6 flex justify-end gap-4 items-center">
        <div class="w-44 mdmax:w-full">
          <LinkButton buttonText="Kembali" url="/order/pickup" linkType="internal" size="big_full" type="secondary" />
        </div>
        <div class="w-44" v-if="!pickupAssignmentDetail?.courier_assigned?.id">
          <Button buttonText="Submit" size="big_full" @action="submit()" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { formatDate, formatDateTime } from '@/util'
export default {
  filters: {
    formatDate,
    formatDateTime
  },
  components: {
    Info: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Info'),
    Button: () => import(/* webpackChunkName: "form" */ '@/components/Forms/Button'),
    LinkButton: () => import(/* webpackChunkName: "form" */ '@/components/Forms/LinkButton'),
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    Search: () => import(/* webpackChunkName: "Forms" */ '@/components/Icons/Search'),
    Pagination: () => import(/* webpackChunkName: "Pagination" */ '@/components/Pagination/Pagination'),
    TableComponent: () => import(/* webpackChunkName: "Table" */ '@/components/Table/Table')
  },
  data() {
    return {
      courierSearchTerm: null,
      status: {
        internal: 'text-primary-500 bg-primary-100',
        external: 'text-secondary-500 bg-secondary-200'
      },
      deliveryServiceTypeList: [
        {
          name: 'Pickup and Dropoff',
          value: 'A'
        },
        {
          name: 'Pickup Only',
          value: 'P'
        },
        {
          name: 'Dropoff Only',
          value: 'D'
        }
      ],
      rejectReasons: ['Barang Terlarang', 'Kurang Bayar', 'Lainnya'],
      selectedReason: null,
      searchTerm: '',
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      selectedCourier: null,
      columns: [
        { label: 'No', field: 'no' },
        { label: 'Kurir', field: 'courier' },
        { label: 'Jarak Terdekat', field: 'distance_in_meter' },
        { label: 'Action', field: 'action' }
      ],
      error: null
    }
  },
  computed: {
    ...mapGetters('assignment', ['pickupAssignmentDetail', 'nearByCouriers']),
    pickupId() {
      return this.$route.params.id
    },
    statusClass() {
      return this.status[this.pickupAssignmentDetail.courier_type]
    },
    filteredData() {
      let temp = this.nearByCouriers || []
      temp = temp.filter((item) => {
        return item.id !== ''
      })
      return temp
    },
    start() {
      return (this.currentPage - 1) * this.perPage + 1
    },
    end() {
      const lastOnPage = (this.currentPage - 1) * this.perPage + this.perPage
      return lastOnPage > this.total ? this.total : lastOnPage
    }
  },
  created() {
    this.getPickupInfo()
  },
  methods: {
    ...mapActions('assignment', ['getPickupAssignmentDetail', 'getNearByCouriers', 'assignCourier']),
    ...mapActions('common', ['showLoading', 'hideLoading', 'setToast']),
    searchCourier() {
      this.getCouriers(this.courierSearchTerm)
    },
    submit() {
      if (!this.selectedCourier) {
        this.error = 'Pilih kurir terlebih dahulu!'
        return
      } else {
        this.error = null
        this.showLoading()
        this.assignCourier({
          pickupId: this.pickupId,
          payloads: {
            courier_id: this.selectedCourier
          }
        }).then(() => {
          this.hideLoading()
          this.setToast({
            options: { type: 'success', duration: 2000, primaryText: 'Kurir berhasil di assign', secondaryText: 'Data telah kami simpan', callback: this.handleCallback }
          })
        })
      }
    },
    selectCourier(id) {
      this.selectedCourier = id
    },
    handleCallback() {
      this.$router.push('/order/pickup')
    },
    convertDistance(distanceInMeters) {
      return Math.ceil(distanceInMeters / 1000) + ' KM'
    },
    onPageChange(page) {
      this.currentPage = page
      this.getCouriers()
    },
    getCouriers(searchTerm = '') {
      this.getNearByCouriers({
        pickupId: this.pickupId,
        params: {
          page: this.currentPage,
          per_page: this.pageSize,
          search_keyword: searchTerm,
          sort: 'DESC'
        }
      }).then((res) => {
        this.totalRecords = res.data.meta.total_item
        this.hideLoading()
      })
    },
    reverseObject(array) {
      let newArr = Object.assign([], array)
      return newArr && newArr.reverse()
    },
    getServiceType(value) {
      return this.deliveryServiceTypeList.filter((item) => item.value === value)[0]?.name
    },
    getPickupInfo() {
      this.showLoading()
      this.getPickupAssignmentDetail({
        pickupId: this.pickupId
      }).then(() => {
        if (this.pickupAssignmentDetail.courier_type === 'internal' && !this.pickupAssignmentDetail?.courier_assigned?.id) {
          this.getCouriers()
        } else {
          this.hideLoading()
        }
      })
    }
  }
}
</script>
<style></style>
